var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSubjectImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 105,
    viewBox: "0 0 115 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1647_33368)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.7827 85.907C78.55 85.907 98.6278 66.676 98.6278 42.9535C98.6278 19.2309 78.55 0 53.7827 0C29.0154 0 8.9375 19.2309 8.9375 42.9535C8.9375 66.676 29.0154 85.907 53.7827 85.907Z",
    fill: "#AED3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3002 88.5969C81.0676 88.5969 101.145 69.366 101.145 45.6434C101.145 21.9208 81.0676 2.68991 56.3002 2.68991C31.5329 2.68991 11.4551 21.9208 11.4551 45.6434C11.4551 69.366 31.5329 88.5969 56.3002 88.5969Z",
    fill: "#AED3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.2656 100.47L99.4581 104.867C103.313 105.448 106.912 102.81 107.495 98.9747L114.936 50.09C115.52 46.2549 112.868 42.6752 109.012 42.0945L79.8199 37.6973C75.9647 37.1166 72.3663 39.7548 71.7826 43.5899L64.3421 92.4746C63.7584 96.3097 66.4104 99.8894 70.2656 100.47Z",
    fill: "#00479B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7502 98.7191L98.9444 103.267C102.523 103.806 105.863 101.357 106.405 97.7973L113.642 50.2463C114.184 46.6863 111.723 43.3634 108.144 42.8244L77.9499 38.2763C74.3713 37.7373 71.031 40.1862 70.4891 43.7462L63.2516 91.2972C62.7098 94.8572 65.1717 98.1801 68.7502 98.7191Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.289 65.2039L105.526 70.2104L105.936 67.5201L72.6984 62.5136L72.289 65.2039Z",
    fill: "#006AEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.364 71.2867L104.602 76.2932L105.011 73.6029L71.7734 68.5964L71.364 71.2867Z",
    fill: "#006AEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4362 77.3602L103.674 82.3667L104.083 79.6765L70.8457 74.6699L70.4362 77.3602Z",
    fill: "#006AEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.8823 48.0154L104.346 51.8509L104.755 49.1606L79.2917 45.3251L78.8823 48.0154Z",
    fill: "#006AEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.54 86.8575L70.3887 82.1622L69.1649 90.1973L100.316 94.8926L101.54 86.8575Z",
    fill: "#75B2FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.319 56.6405L75.208 51.9543L74.4462 56.9593L105.557 61.6455L106.319 56.6405Z",
    fill: "#75B2FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 34.7519C0 36.7666 0.600414 38.7359 1.72551 40.411C2.85061 42.0861 4.44988 43.3917 6.32085 44.1626C8.19182 44.9336 10.2505 45.1353 12.2367 44.7423C14.2229 44.3492 16.0474 43.3791 17.4794 41.9546C18.9114 40.53 19.8866 38.715 20.2817 36.7391C20.6768 34.7632 20.474 32.7152 19.699 30.8539C18.924 28.9926 17.6116 27.4018 15.9278 26.2825C14.244 25.1633 12.2642 24.5659 10.2391 24.5659C7.52351 24.5659 4.91922 25.6391 2.999 27.5493C1.07878 29.4596 0 32.0504 0 34.7519Z",
    fill: "#75B2FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8325 45.4031C62.403 47.5652 60.3217 50.0855 58.661 52.876C56.8451 56.1721 55.3674 59.6418 54.2504 63.2326C50.6987 63.0132 47.1356 63.0573 43.5905 63.3643C40.0438 63.79 36.5817 64.7438 33.3202 66.1938L25.3252 56.3721L58.0532 33.1163L64.8325 45.4031Z",
    fill: "#388AE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.9783 28.845L45.1337 54.5271L17.8682 61.0233L38.705 35.3411L65.9783 28.845Z",
    fill: "#00479B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7906 43.0388C39.9984 40.0543 38.0582 35.9612 39.4063 33.3643C41.0271 30.2636 46.5206 30.9535 49.3648 30.9225C55.6844 30.8605 63.5782 27.0465 69.3836 9.42636",
    stroke: "#006AEA",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.3076 13.0853C68.3076 11.907 68.4323 10.4341 68.8842 10.1473C69.3362 9.86047 70.1934 11.3488 70.6219 12.062C71.5804 13.6124 73.1467 14.6977 75.7338 11.8992",
    stroke: "#006AEA",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1647_33368"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 115,
    height: 105,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubjectImg);
export default __webpack_public_path__ + "static/media/SubjectImg.ccf9e218915eee54a7e36aad4f2ae5c2.svg";
export { ForwardRef as ReactComponent };